import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0d0d03aa&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0d03aa')) {
      api.createRecord('0d0d03aa', component.options)
    } else {
      api.reload('0d0d03aa', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0d0d03aa&", function () {
      api.rerender('0d0d03aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26u8e383uWq7X/JS/comp/childrenage.vue"
export default component.exports